import { styled } from '../../../stitches.config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { keyframes } from '@stitches/react';
import * as React from 'react';
import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';
import Button from '@/components/sushi/Button';
import { useIntl } from 'react-intl';

export const CopyButton = ({
  value,
  children,
  onClick,
}: React.PropsWithChildren<{
  value: string;
  onClick?: React.MouseEventHandler;
}>) => {
  const { formatMessage } = useIntl();
  const [feedback, setFeedback] = React.useState<boolean>();
  const icon = feedback === undefined ? faCopy : feedback ? faCheck : faTimes;
  const lastFeedback = React.useRef<Date>();

  return (
    <Button
      variant={'primaryDark'}
      size={'small'}
      onClick={(event) => {
        lastFeedback.current = new Date();
        navigator.clipboard
          .writeText(value)
          .then(() => {
            setFeedback(true);
          })
          .catch(() => {
            setFeedback(false);
          })
          .finally(() => {
            setTimeout(() => {
              setFeedback(undefined);
            }, 2000);
          });
        onClick?.(event);
      }}>
      <CopyButtonContent>
        <span>
          {feedback
            ? formatMessage({ id: 'budget_calculator.share_results_link_copied' })
            : children}
        </span>
        <CopyButtonIcon
          key={feedback?.toString()}
          icon={icon}
          size="1x"
          animate={!!lastFeedback.current}
        />
      </CopyButtonContent>
    </Button>
  );
};

const grow = keyframes({
  '0%': { transform: 'scale(0)', opacity: 0 },
  '100%': { transform: 'scale(1)', opacity: 1 },
});

const CopyButtonContent = styled('span', {
  display: 'flex',
  gap: 8,
  alignItems: 'center',
});

const CopyButtonIcon = styled(FontAwesomeIcon, {
  width: 16,
  variants: {
    animate: {
      true: {
        animation: `${grow} 180ms ease-out`,
      },
    },
  },
});
